module.exports = __webpack_public_path__ + "officialStatic/img/solutionActive4.d81a243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solutionActive4.png
// module id = Tp3u
// module chunks = 0